import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Locations_ds_get_inventory_locations_by_parentIdService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { parentId: number }): 
  Promise<{ result: { Id?: number, EligibleForAllocation?: boolean, IsLoose?: boolean, Name?: string, ParentId?: number, StatusId?: number, TypeId?: number, WarehouseId?: number, Status?: { Name?: string }, Warehouse?: { Name?: string }, Type?: { Name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.parentId)) {
      missingRequiredInParams.push('\'parentId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Locations/datasources/ds_get_inventory_locations_by_parentId/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { parentId: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, EligibleForAllocation?: boolean, IsLoose?: boolean, Name?: string, ParentId?: number, StatusId?: number, TypeId?: number, WarehouseId?: number, Status?: { Name?: string }, Warehouse?: { Name?: string }, Type?: { Name?: string } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.parentId)) {
      missingRequiredInParams.push('\'parentId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Locations/datasources/ds_get_inventory_locations_by_parentId/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { parentId: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, EligibleForAllocation?: boolean, IsLoose?: boolean, Name?: string, ParentId?: number, StatusId?: number, TypeId?: number, WarehouseId?: number, Status?: { Name?: string }, Warehouse?: { Name?: string }, Type?: { Name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.parentId)) {
      missingRequiredInParams.push('\'parentId\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Locations/datasources/ds_get_inventory_locations_by_parentId/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}
